import styled from 'styled-components';
import { Icon } from '../icon';
const ToggleContainerConfig = {
    small: {
        width: '32px',
        height: '16px',
        lineHeight: '16px',
    },
    medium: {
        width: '40px',
        height: '24px',
        lineHeight: '24px',
    },
    large: {
        width: '60px',
        height: '36px',
        lineHeight: '36px',
    },
};
const sliderConfig = {
    small: {
        size: {
            width: '12px',
            height: '12px',
        },
        sliderPosition: '17px',
    },
    medium: {
        size: {
            width: '16px',
            height: '16px',
        },
        sliderPosition: '21px',
    },
    large: {
        size: {
            width: '24px',
            height: '24px',
        },
        sliderPosition: '32px',
    },
};
const xDifPos = {
    small: '- 3px',
    medium: '- 2px',
    large: '- 1px',
};
const yDifPos = {
    small: '- 4.5px',
    medium: '- 1.2px',
    large: '+ 2px',
};
export const ToggleContainer = styled.label `
  position: relative;
  display: block;
  width: ${({ size }) => ToggleContainerConfig[size].width};
  height: ${({ size }) => ToggleContainerConfig[size].height};
  line-height: ${({ size }) => ToggleContainerConfig[size].lineHeight};
`;
export const MakeToggleSlider = ({ theme, disabled, checked = false, size }) => {
    const setBgColor = () => {
        if (disabled) {
            return theme.colors.grey24;
        }
        if (!checked) {
            return theme.toggle.unChecked.bg;
        }
        return theme.toggle.checked.bg;
    };
    const setBorder = () => {
        if (disabled && !checked) {
            return theme.colors.grey36;
        }
        if (!checked) {
            return theme.colors.grey24;
        }
        return 'transparent';
    };
    const sliderColor = checked ? theme.toggle.checked.slide : theme.toggle.unChecked.slide;
    return `
    position: absolute;
    cursor: ${disabled ? 'default' : 'pointer'};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${setBgColor()};
    border-radius: 100px;
   border: 1px solid ${setBorder()};

    &:before{
      position: absolute;
      content:'';
      left: 3px;
      ${checked ? `left: ${sliderConfig[size].sliderPosition};` : `4px;`} 
      top: 50%;
      transform: translate( 0, -50% );
      width: ${sliderConfig[size].size.width};
      height: ${sliderConfig[size].size.height};
      background-color: ${disabled ? theme.toggle.disabled.slide : sliderColor};
      transition: left 0.2s;
      border-radius: 50%;
    }
  `;
};
export const ToggleInput = styled.input `
  display: none !important;
`;
const horizontalPos = {
    small: '161%',
    medium: '194%',
    large: '230%',
};
export const CustomIcon = styled(Icon) `
  display: block;
  position: absolute;
  transform: translate(
    ${({ position, checked }) => `calc(${checked ? horizontalPos[position] : '50%'} ${xDifPos[position]}),calc(50% ${yDifPos[position]})`}
  );
`;
export const ToggleSlider = styled.span `
  ${(props) => MakeToggleSlider(props)}
`;
